
<div class="flexContainer" style="margin-left: 10%;margin-right: 10%;">
  <div class="title">
    <h1>{{'Setup Departments' | translate | async}}</h1>
  </div>


  <div *ngIf="departmentlist.length > 0">
    <mat-list role="list" *ngFor="let cat of departmentlist; index as catIndex">
      <mat-list-item role="listitem">
        <div class="listItemContainer">
          <span class="CatTitle">{{cat.DepartmentName}} </span>
          <button mat-button (click)="OpenEditDepDialog(cat)" class="crt">
            <mat-icon click>create</mat-icon>
          </button>
        </div>

      </mat-list-item>



      <ng-container *ngFor="let qus of worklist; let i = index">
        <tr *ngIf="qus.DepartmentID==cat.ID">
          <td>
            <button mat-button (click)="ChangeActive(qus)" mat-icon->
              <mat-icon *ngIf="qus.Active" style="color:green">done</mat-icon>
              <mat-icon *ngIf="!qus.Active" style="color:red">close</mat-icon>
            </button>
          </td>
          <td>
            <span class="SectionTitle">{{qus.WorkAreaName}} </span>
          </td>
          <td>
            <button mat-button (click)="OpenEditWorkArea(qus)" mat-icon->
              <mat-icon>create</mat-icon>
            </button>
          </td>
        </tr>
        
      </ng-container>

      <div class="addSectionButton">
        <button (click)="openAddwork(cat)" mat-raised-button color="lightgray">
          <i class="material-icons alert__icon">add</i>
          {{'Add Work Area' | translate | async}}
        </button>
      </div> 

   


    </mat-list>
  </div>
  <div class="row">
    <div class="marg">
      <div class="column">
        <button (click)="openAddDepartmentDialog()" mat-raised-button color="lightgray">
          <mat-icon>add</mat-icon>{{"Add Department" | translate | async}}
        </button>
      </div>
    </div>
  </div>





</div>




